/* unplugin-vue-components disabled */
import {Rest} from 'utils'
import {API_PLAYGROUND} from 'consts/api'

export default {
  mixins: [ModelValue(String)],
  props: {
    required: {type: Boolean, default: false}
  },
  data() {
    return {
      rest: new Rest(),
      el_value: undefined,
      last_query: undefined,
      last_res: []
    }
  },
  computed: {
    empty() {
      return !this.value
    }
  },
  async mounted() {
    const items = await this.rest.get(`${API_PLAYGROUND}/prompts`)
    const res = items.map(item => ({label: item.name, value: item.name}))

    this.last_query = ''
    this.last_res = res
  },
  methods: {
    async loadAsync(query, cb) {
      if (this.value === this.el_value) {
        return cb([])
      }
      if (this.last_query === query) {
        return cb(this.last_res)
      }
      const items = await this.rest.get(`${API_PLAYGROUND}/prompts`, {query: query})

      if (!items?.length) {
        this.last_query = query
        this.last_res = []
        return cb([])
      }
      
      const res = items.map(item => ({label: item.name, value: item.name}))

      this.last_query = query
      this.last_res = res
    
      cb(res)
    },
    onSelect(item) {
      this.value = item.value
    },
    onFocus(){
      const input = this.$refs.el_autocomplete?.inputRef
      if (input) input.select()
    },
    onBlur(){
      // if value === '' - we fetching new data or showing last query
      this.el_value = this.value || undefined 
    }
  }
}
